const chains = [];
chains.push({ _operation: 'authenticate', api: '/user-authentication/authenticate', defaultData: null, httpVerb: 'post' });
chains.push({ _operation: 'authorize', api: '/user-authentication/authorize', defaultData: null, httpVerb: 'post' });
chains.push({ _operation: 'refresh', api: '/user-authentication/refresh', defaultData: null, httpVerb: 'post' });
export default chains;
